import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { ChatLegacyComponent } from './chat-legacy.component';
import { FileUploadLegacyComponent } from './file-upload-legacy/file-upload-legacy.component';
import { MessageLegacyService } from './services/message-legacy.service';
import { TelInputLegacyDirective } from './tel-input-legacy/tel-input-legacy.directive';
import { TextareaAutoExpandLegacyDirective } from './textarea-auto-expand-legacy.directive';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  declarations: [
    ChatLegacyComponent,
    FileUploadLegacyComponent,
    TextareaAutoExpandLegacyDirective,
    TelInputLegacyDirective,
  ],
  exports: [ChatLegacyComponent],
  providers: [MessageLegacyService],
})
export class ChatLegacyModule {}
